"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogLevel = void 0;
exports.debug = debug;
exports.error = error;
exports.info = info;
exports.setLogLevel = setLogLevel;
exports.warn = warn;
var LogLevel;
exports.LogLevel = LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["ERROR"] = 0] = "ERROR";
  LogLevel[LogLevel["WARN"] = 1] = "WARN";
  LogLevel[LogLevel["INFO"] = 2] = "INFO";
  LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
// 0, 1, 2, 3
// Can be accessed by importing @lsg/utils
// Set log-level with .setLogLevel( LogLevel.ERROR );
//Setting inital Log Level
var activeLogLevels = LogLevel.INFO;
function setLogLevel(logLevel) {
  activeLogLevels = logLevel;
}
function debug(message) {
  var _console;
  for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    optionalParams[_key - 1] = arguments[_key];
  }
  activeLogLevels == LogLevel.DEBUG && (_console = console).log.apply(_console, [message].concat(optionalParams));
}
function info(message) {
  var _console2;
  for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    optionalParams[_key2 - 1] = arguments[_key2];
  }
  activeLogLevels >= LogLevel.INFO && (_console2 = console).info.apply(_console2, [message].concat(optionalParams));
}
function warn(message) {
  var _console3;
  for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    optionalParams[_key3 - 1] = arguments[_key3];
  }
  activeLogLevels >= LogLevel.WARN && (_console3 = console).warn.apply(_console3, [message].concat(optionalParams));
}
function error(message) {
  var _console4;
  for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    optionalParams[_key4 - 1] = arguments[_key4];
  }
  activeLogLevels >= LogLevel.ERROR && (_console4 = console).error.apply(_console4, [message].concat(optionalParams));
}